import $ from 'jquery';
import 'slick-carousel';

const classNames = {
  AUTHOR_HIDDEN: `about__photo-author--hidden`,
  CONTROLS_VISIBLE: `about__slider-controls--visible`,
  CONTROL_ACTIVE: `about__slider-control--active`
};

export default function initAboutSlider(page) {
  const slider = page.querySelector(`#about-slider`);
  const sliderControlsWrap = page.querySelector(`.about__slider-controls`);
  const sliderControls = [...page.querySelectorAll(`.about__slider-control`)];
  // const details = page.querySelector(`.about__link`);
  const aboutSlider = $('.flats-types__toggles--footer');
  const anchorLinks = document.querySelectorAll('.anchor-link');
  const allRestorationLinks = document.querySelectorAll("[data-link='restoration']");
  const allFilmsLinks = document.querySelectorAll("[data-link='film']");
  const allPhotoprojectsLinks = document.querySelectorAll("[data-link='photoproject']");
  const toggleControlsState = (year) => {
    const {
      CONTROL_ACTIVE: activeClass
    } = classNames;

    sliderControls.forEach(control => control.classList.remove(activeClass));
    sliderControls.find(control => control.dataset.year === year).classList.add(activeClass);
  };

  $(slider).slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    useCSS: false
  });

  aboutSlider.fadeOut();

  $(slider).on(`beforeChange`, (e, slick, currentSlide, nextSlide) => {
    const active = slider.querySelector(`.about__slide[data-about="${nextSlide}"]`);
    // const activeYear = active.dataset.year;

    // sliderControlsWrap.classList.toggle(classNames.CONTROLS_VISIBLE, !!activeYear);

    // if (activeYear) {
    //   toggleControlsState(activeYear);
    // }

    if (window.innerWidth > 768) {
      if (nextSlide === 0) {
        aboutSlider.fadeOut();
      } else {
        aboutSlider.fadeIn();
      }
    }

    anchorLinks.forEach((link) => {
      link.classList.remove('flats-types__toggle--active')
    })

    if (active.getAttribute('data-slide') === 'restoration') {
      allRestorationLinks.forEach((link) => {
        link.classList.add('flats-types__toggle--active')
      })
    }

    if (active.getAttribute('data-slide') === 'film') {
      allFilmsLinks.forEach((link) => {
        link.classList.add('flats-types__toggle--active')
      })
    }

    if (active.getAttribute('data-slide') === 'photoproject') {
      allPhotoprojectsLinks.forEach((link) => {
        link.classList.add('flats-types__toggle--active')
      })
    }
  });

  sliderControls.forEach(control => {
    control.addEventListener(`click`, ({
      target
    }) => {
      toggleControlsState(target.dataset.year);
    });
  });

  // details.addEventListener(`click`, () => {
  //   $(slider).slick('slickGoTo', 1);
  // })

  anchorLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const dataLink = link.getAttribute('data-link');
      // if (dataLink === 'restoration') $(slider).slick('slickGoTo', 1)
      if (dataLink === 'film') $(slider).slick('slickGoTo', 1)
      if (dataLink === 'photoproject') $(slider).slick('slickGoTo', 13)
      if (dataLink === 'more-about') $(slider).slick('slickGoTo', 14)
    })
  })
};
